import { Client } from 'stompjs';
import { ClientWithTransport } from './socket';

/** `readyState` cua SockJS/WebSocket khi ket noi dang mo. */
const TRANSPORT_OPEN = 1;

export type SocketUnhealthyReason =
  | 'no-client'
  | 'stomp-disconnected'
  | 'transport-closed'
  | 'missing-topics';

export type SocketHealthReport = {
  healthy: boolean;
  reason?: SocketUnhealthyReason;
  /** Cac destination le ra phai co subscription nhung dang thieu. */
  missingTopics?: string[];
};

/**
 * Phien STOMP con song khong: da CONNECTED va transport ben duoi con mo.
 *
 * Chi doc `client.connected` la chua du. Transport co the dong am tham (may ngu,
 * rot Wi-Fi) truoc khi stompjs kip cap nhat co, nen doi chieu them `readyState`.
 * Transport khong lo `readyState` thi bo qua ve nay thay vi bao chet oan.
 */
export const isSessionLive = (client: Client | null): boolean => {
  if (!client?.connected) return false;
  const readyState = (client as ClientWithTransport).ws?.readyState;
  return readyState === undefined || readyState === TRANSPORT_OPEN;
};

/**
 * Bao cao suc khoe cua socket theo tung topic.
 *
 * STOMP khong co trang thai "connected" rieng cho tung topic: subscription song
 * cung phien. Nen "topic con connect" = phien con song VA ta con giu subscription
 * cua topic do tren phien hien tai.
 */
export const checkSocketHealth = (
  client: Client | null,
  expectedTopics: string[],
  subscribedTopics: string[],
): SocketHealthReport => {
  if (!client) return { healthy: false, reason: 'no-client' };
  if (!client.connected) return { healthy: false, reason: 'stomp-disconnected' };
  if (!isSessionLive(client)) return { healthy: false, reason: 'transport-closed' };

  const subscribed = new Set(subscribedTopics);
  const missingTopics = expectedTopics.filter(topic => !subscribed.has(topic));
  if (missingTopics.length) return { healthy: false, reason: 'missing-topics', missingTopics };

  return { healthy: true };
};
